import { atom } from 'recoil';

const pressErrorAtom = atom({
  key: 'pressError',
  default: { Name: '', Type: '', Date: '', Description: '' }
});

export {pressErrorAtom}